export const compactModeHeaderBackground = ({
    assignee,
    activeUser,
    hasTransaction,
    isSideBarPanel = false,
    isTransactionUnassigned,
    isRecentlyFinished = false,
}) => {
    if (isSideBarPanel) {
        return { background: 'transparent' };
    }
    if (isRecentlyFinished) {
        return {
            background: 'linear-gradient(0deg, rgba(32, 32, 32, 0.00) 0%, rgba(38, 38, 38, 0.60) 68.74%), rgba(38, 38, 38, 0.75)',
        };
    }
    if (assignee === activeUser) {
        return {
            background:
                'linear-gradient(0deg, rgba(212, 0, 249, 0.43) 0%, rgba(188, 0, 222, 0.95)100%), linear-gradient(0deg, rgba(32, 32, 32, 0.00) 0%, rgba(38, 38, 38, 0.10) 68.74%),  rgba(38, 38, 38, 0.54)',
        };
    }
    if (isTransactionUnassigned) {
        return {
            background:
                'linear-gradient(0deg, rgba(25, 25, 142, 0.75) 0%, rgba(188, 0, 222, 0.95)100%), linear-gradient(0deg, rgba(32, 32, 32, 0.00) 0%, rgba(38, 38, 38, 0.10) 68.74%),  rgba(38, 38, 38, 0.54)',
        };
    }
    if (hasTransaction) {
        return {
            background:
                'linear-gradient(0deg, rgba(25, 25, 142, 0.75) 0%, rgba(64, 11, 170, 0.81) 100%), linear-gradient(0deg, rgba(32, 32, 32, 0.00) 0%, rgba(38, 38, 38, 0.10) 68.74%), rgba(38, 38, 38, 0.54)',
        };
    }
    return { background: 'linear-gradient(0deg, rgba(32, 32, 32, 0.00) 0%, rgba(38, 38, 38, 0.60) 68.74%), rgba(38, 38, 38, 0.75)' };
};
